import {
  sessionDeleteMutation,
  sessionQueryOptions,
} from '@quoruum/frontend-common/oas/gen/admin/@tanstack/react-query.gen';
import { defineEntitySchema } from './base/EntitySchema';

// The API has no get-by-id for sessions, so there is no `read` endpoint.
export const sessionSchema = defineEntitySchema({
  name: 'session',
  label: 'Session',
  idField: 'id',
  primaryText: (session) => session.label || session.type || '',
  secondaryText: 'organizationId',
  endpoints: {
    query: sessionQueryOptions,
    delete: {
      mutation: sessionDeleteMutation,
      toRequest: (id) => ({ path: { sessionId: id } }),
    },
  },
  fields: [
    { key: 'id', label: 'ID', type: 'string', readOnly: true },
    { key: 'type', label: 'Type', type: 'enum', options: ['WEB', 'API'], readOnly: true },
    { key: 'label', label: 'Label', type: 'string', readOnly: true },
    { key: 'organizationId', label: 'Organization', type: 'string', readOnly: true },
    { key: 'expiration', label: 'Expires', type: 'datetime', readOnly: true },
    { key: 'auditBean.created', label: 'Created', type: 'datetime', readOnly: true },
    { key: 'auditBean.timestamp', label: 'Last Modified', type: 'datetime', readOnly: true },
  ],
});
